"use client";

import { AnimatedSectionHeader } from "@/components/typography/AnimatedSectionHeader";
import { AboutStoryTimeline } from "@/components/about/AboutStoryTimeline";
import { Reveal } from "@/components/motion";
import type { AboutStoryContent } from "@/lib/api-types";

interface AboutStorySectionProps {
  story: AboutStoryContent;
}

export function AboutStorySection({ story }: AboutStorySectionProps) {
  return (
    <section className="site-section bg-[var(--site-surface-alt)]">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <AnimatedSectionHeader
            kineticTrigger="mount"
            title="Our Story & Purpose"
            subtitle="A Beacon of Hope in a Diverse Nation"
          />
        </Reveal>

        <Reveal className="mb-10 md:mb-12">
          <article className="site-card mx-auto max-w-4xl p-6 md:p-8">
            <h3 className="mb-4 font-display text-2xl font-bold text-[var(--site-primary)] md:text-3xl">
              {story.overviewTitle}
            </h3>
            {story.overviewParagraphs.map((p) => (
              <p
                key={p.slice(0, 40)}
                className="mb-4 last:mb-0 leading-relaxed text-[var(--site-muted)] md:text-lg"
              >
                {p}
              </p>
            ))}
          </article>
        </Reveal>

        <AboutStoryTimeline items={story.timeline} />

        <Reveal className="mt-10 md:mt-12">
          <div className="about-story-quote site-card mx-auto max-w-3xl p-6 md:p-8">
            <blockquote className="text-center font-display text-lg italic leading-relaxed text-[var(--site-text)] md:text-xl">
              &ldquo;{story.quote}&rdquo;
            </blockquote>
            <p className="mt-6 text-center leading-relaxed text-[var(--site-muted)]">
              {story.closing}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
